export const StepEvents = {
  SAVE: 'SAVE',
  DONE_SAVING: 'DONE_SAVING',
  FAILED_SAVING: 'DAILED_SAVING',
  DONE_LOADING: 'DONE_LOADING',
  FAILED_LOADING: 'FAILED_LOADING',
  CANCEL: 'CANCEL',
  ACTIVATE: 'ACTIVATE',
  DEACTIVATE: 'DEACTIVATE',
  UPDATE_VALIDATION: 'UPDATE_VALIDATION',
  STOP: 'STOP',
  DONE_STOPPING: 'DONE_STOPPING',

  OVERRIDE_ACTIONS: 'OVERRIDE_ACTIONS',
  OVERRIDE_GUARDS: 'OVERRIDE_GUARDS',
};
